/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/data/entity';

import { getVariant } from 'solis/type/hex/variants';


export default class ColonyDraft extends Entity
{
  getZones ()
  {
    return getVariant(this.cass.size, this.cass.variant).rotateRight(this.cass.rotation);
  }


};
